import ReactPlayer from 'react-player';
import React, { useRef } from "react";


export function VideoPlayer({ 
  url, 
  isPlaying, 
  onPlayPause, 
  onEnd, 
  trainingId  // Changed from dayId to trainingId
}) {
  const playerRef = useRef(null);

  return (
    <div className="rounded-lg overflow-hidden">
      {/* Video Player */}
      <div className="aspect-video bg-muted">
        <ReactPlayer
          ref={playerRef}
          url={url}
          playing={isPlaying}
          controls
          width="100%"
          height="100%"
          onEnded={() => onEnd(trainingId)}  // Changed dayId to trainingId
          onPlay={() => onPlayPause(true)}
          onPause={() => onPlayPause(false)}
          config={{
            youtube: {
              playerVars: { 
               modestbranding: 1,
                rel: 0,          
                showinfo: 0,    
                iv_load_policy: 3, 
                fs: 0,           
                controls: 1,      
                disablekb: 0,   
                playsinline: 1,  
                autohide: 1,      
                autoplay: 0   
              }
            }
          }}
        />
      </div>

    </div>
  );
}